import { render, staticRenderFns } from "./_sidebarMenu.vue?vue&type=template&id=c6456f48"
import script from "./_sidebarMenu.vue?vue&type=script&lang=js"
export * from "./_sidebarMenu.vue?vue&type=script&lang=js"
import style0 from "./_sidebarMenu.vue?vue&type=style&index=0&id=c6456f48&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports